import type { JSX } from 'react';
import type { CandidateStatus } from '../types/candidate.types';
import { ConfirmDialog } from './ConfirmDialog';

interface CandidateConfirmDialogsProps {
  candidateName: string;
  candidateId: string;
  showDeleteConfirm: boolean;
  onDeleteConfirmChange: (open: boolean) => void;
  onDelete: (id: string) => void;
  showStatusConfirm: boolean;
  onStatusConfirmChange: (open: boolean) => void;
  pendingStatus: CandidateStatus | null;
  onStatusConfirm: () => void;
}

export function CandidateConfirmDialogs({
  candidateName,
  candidateId,
  showDeleteConfirm,
  onDeleteConfirmChange,
  onDelete,
  showStatusConfirm,
  onStatusConfirmChange,
  pendingStatus,
  onStatusConfirm,
}: CandidateConfirmDialogsProps): JSX.Element {
  return (
    <>
      <ConfirmDialog
        open={showDeleteConfirm}
        onOpenChange={onDeleteConfirmChange}
        title="Delete Candidate"
        description={`Are you sure you want to delete "${candidateName}"? This action cannot be undone.`}
        onConfirm={() => onDelete(candidateId)}
        confirmLabel="Delete"
        variant="destructive"
      />
      <ConfirmDialog
        open={showStatusConfirm}
        onOpenChange={onStatusConfirmChange}
        title="Change Candidate Status"
        description={`Are you sure you want to change the status of "${candidateName}" to ${pendingStatus}?`}
        onConfirm={onStatusConfirm}
        confirmLabel="Change Status"
      />
    </>
  );
}
